import {JsonProperty} from '@hyperloris/tyson';
import {DateTime} from 'luxon';

export class ExecTrader {


  @JsonProperty()
  id: number = -1;

  @JsonProperty()
  ownerId: number;

  @JsonProperty()
  owner: string | undefined;

  @JsonProperty()
  code: string | undefined;

  @JsonProperty()
  name: string | undefined;

  @JsonProperty()
  address: string | undefined;

  @JsonProperty()
  zipCode: string | undefined;

  @JsonProperty()
  town: string | undefined;

  @JsonProperty()
  country: string | undefined;

  @JsonProperty()
  stateAddress: string | undefined;

  @JsonProperty()
  desk: string | undefined;

  @JsonProperty()
  email: string | undefined;

  @JsonProperty()
  currency: string | undefined;

  @JsonProperty()
  enabled: boolean = true;

  @JsonProperty()
  modificationDate: DateTime = DateTime.now();

  @JsonProperty()
  invoiceMail: string | undefined;

  @JsonProperty()
  outstandingDebt: number = 0;

  @JsonProperty()
  bankAccountId: number = 0;

  @JsonProperty()
  billingDueNbDays: number = 0;

  @JsonProperty()
  moneyOwner: string | undefined;


  @JsonProperty()
  vat: boolean | undefined;

  @JsonProperty()
  vatNumber: string | undefined;

  @JsonProperty()
  lei: string | undefined;

  @JsonProperty()
  brokerageTableName: string | undefined;

  @JsonProperty()
  invoiceTemplate: string | undefined;
}

